// extracted by mini-css-extract-plugin
export default {"edit_your_box":"ul","edit_box_title":"vl","subscription":"wl","byb":"xl","recommended_for_you_title":"yl","explore":"zl","recommended":"Al","go_back":"Bl","wrapper":"Cl","product_img":"El","info":"Fl","remove_btn":"Gl"};
    if(module.hot) {
      // 1721922359070
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  